import styled from "styled-components";
import { Typography } from "@material-ui/core";

export const STDescriptionTypography = styled(Typography)`
  && {
    opacity: 0.8;
    font-size: 0.875rem;
  }
`;
